/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The state of a dynamic export run
 */
export enum EnumDynamicExportRunState {
    /**
     * Export run is scheduled
     */
    Scheduled = 0,
    /**
     * Export run is currently running
     */
    Running = 1,
    /**
     * Export run has finished successfully
     */
    Finished = 2,
    /**
     * Export run has failed
     */
    Failed = 3,
}
